import { FencingIcon } from './FencingIcon';

/**
 * author: Google
 * id 325210DA-E889-4CBD-B0A7-8A32D706322B
 * name fencing
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fencing.svg
 * tags
 * - Sport 
 */
export const SwordFightIcon = FencingIcon;
export default SwordFightIcon